import { bl_fi_nsti_stock_import_file_helper_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class NstiStockImportFileHelperContainerModel extends BaseContainerModel {
  bl_fi_nsti_stock_import_file_helper: bl_fi_nsti_stock_import_file_helper_RowClass = new bl_fi_nsti_stock_import_file_helper_RowClass();
}
